export * from './umpire-quiz-prize';
